import React from "react";

const Gallery = () => {
  return (
    <>
      <section className="bd-team pt-80">
        <div className="container">
          <div
            className="row justify-content-center wow fadeInUp"
            data-wow-delay=".3s"
          >
            <div className="col-lg-8">
              <div className="bd-section__title mb-45 text-center">
                <h2 className="bd__title">Gallery</h2>
              </div>
            </div>
          </div>
          <div className="row wow fadeInUp" data-wow-delay=".5s">
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/1.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/2.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/3.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/4.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/5.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/6.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/7.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/8.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/9.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/10.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/11.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/12.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/13.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/14.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/15.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/16.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img
                      src="./assets/img/Gallery/gallaryimage2.jpeg"
                      alt="team img"
                    />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img
                      src="./assets/img/Gallery/gallaryimage3.jpeg"
                      alt="team img"
                    />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img
                      src="./assets/img/Gallery/gallaryimage4.jpeg"
                      alt="team img"
                    />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img
                      src="./assets/img/Gallery/gallaryimage5.jpeg"
                      alt="team img"
                    />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img
                      src="./assets/img/Gallery/gallaryimage1.jpeg"
                      alt="team img"
                    />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/1.jpeg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/2.jpeg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/90.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/2.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/3.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/3.jpeg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/6.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/14.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/20.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/22.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/23.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/24.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/25.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/63.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/73.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/87.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/95.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/features/104.jpg" alt="team img" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img
                      src="./assets/img/features/out sid.jpg"
                      alt="team img"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="bd-team pt-80">
        <div className="container">
          <div
            className="row justify-content-center wow fadeInUp"
            data-wow-delay=".3s"
          >
            {/* <div className="col-lg-8">
              <div className="bd-section__title mb-45 text-center">
                <h2 className="bd__title">Gallery</h2>
              </div>
            </div> */}
          </div>
          <div className="row wow fadeInUp" data-wow-delay=".5s">
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/02.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/2.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/3.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/4.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/5.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            {/* <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/6.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div> */}
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/7.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/8.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/9.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/10.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/11.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/12.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/13.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/14.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/15.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/16.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/17.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/18.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/19.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/20.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/21.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/22.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/23.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/24.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/25.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/26.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/27.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/28.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/29.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/30.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/31.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/32.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/33.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/34.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/35.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/36.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/37.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/38.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/39.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/40.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/41.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/42.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/43.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
           
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/45.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/46.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>


            <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="bd-team__item border-radius-6 mb-40">
                <div className="bd-team__thum w-img">
                  <a>
                    <img src="./assets/img/Gallery/webp/01.webp" alt="team img" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Gallery;
